import axios from 'axios';

import history from './history';
import config from '../config';

import UserAPI from './UserAPI';

const apiPath = config.api.proposalCalls;

function url(...rest) {
  return rest.map(val => `${val}`.replace(/\/$/, '')).join('/');
}

class ScheduleAPI {
  static facilities() {
    return axios({
      method: 'get',
      url: url(config.api.proposalCalls, 'scheduling'),
      responseType: 'json',
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }

  static master() {
    return axios({
      method: 'get',
      url: url(config.api.proposalCalls, 'masterSchedule'),
      responseType: 'json',
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }

  static addEvent(proposalId, formId, groupId, data) {
    return axios({
      method: 'post',
      url: url(apiPath, proposalId, 'values'),
      params: { formId, groupId },
      data,
      responseType: 'json',
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }

  static editEvent(proposalId, formId, groupId, data) {
    return axios({
      method: 'put',
      url: url(apiPath, proposalId, 'values'),
      params: { formId, groupId },
      data,
      responseType: 'json',
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }

  static deleteEvent(proposalId, formId, groupId) {
    return axios({
      method: 'delete',
      url: url(apiPath, proposalId, 'values'),
      params: { formId, groupId },
      responseType: 'json',
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }

  static search(searchParams) {
    return axios({
      method: 'get',
      url: url(config.api.proposalCalls, 'scheduling'),
      params: searchParams,
      responseType: 'json',
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }

  static collaboratorEvents(proposalId, userId) {
    return axios({
      method: 'get',
      url: url(config.api.proposals, proposalId, 'collaborationEvents'),
      params: { userId },
      responseType: 'json',
      headers: {
        Authorization: `Bearer ${UserAPI.token()}`
      }
    });
  }
}

export default ScheduleAPI;
